import {z as r} from 'zod';

import {CommentsLayoutType} from '../reviews-report';

import {
    exportColumnCatalogItemSchema,
    exportColumnFormatSchema,
    exportConstructorLimitsSchema,
    exportTemplateColumnSchema,
    exportTemplateSchema,
} from './export-constructor-schema';

export type ExportColumnFormatType = r.infer<typeof exportColumnFormatSchema>;

export type ExportTemplateColumnType = r.infer<typeof exportTemplateColumnSchema>;

export type ExportTemplateType = r.infer<typeof exportTemplateSchema>;

export type ExportColumnCatalogItemType = r.infer<typeof exportColumnCatalogItemSchema>;

export type ExportConstructorLimitsType = r.infer<typeof exportConstructorLimitsSchema>;

export enum SystemExportTemplateCodeEnum {
    Base = 'base',
    Base1 = 'base1',
    Base2 = 'base2',
    Base3 = 'base3',
    Base4 = 'base4',
}

export type CreateExportTemplatePayloadType = {
    name: string;
    columns: Array<ExportTemplateColumnType>;
    parent: number;
};

export type UpdateExportTemplatePayloadType = Partial<CreateExportTemplatePayloadType>;

export type ExportConstructorExportPayloadType = {
    templateId?: number;
    systemTemplateCode?: SystemExportTemplateCodeEnum;
    customReportName?: string;
    additionalUserEmails?: string;
    commentsLayout?: CommentsLayoutType;
    withReviewsSummary?: boolean;
    withTagsStat?: boolean;
};
